import { useNavigate } from "react-router-dom";
import BaseLayout from "../components/layout/BaseLayout";
import { PiCheckFatLight } from "react-icons/pi";
import keycloak from "../config/keycloak";

export const HomePage = () => {
  const navigate = useNavigate();

  return (
    <BaseLayout>
      <div className="flex flex-col gap-4 md:flex-row items-center justify-around w-full px-6 md:px-10 mb-10">
        <div className="flex flex-col gap-4 md:gap-12 order-1 w-full md:w-2/6">
          <div className="flex flex-1 flex-col">
            <h3 className="text-2xl md:text-5xl font-bold mb-2">Dein Feldkalender für eine moderne Landwirtschaft</h3>
            <p className="text-xl text-gray-600">Mit Ackerplus behältst du deine Felder stets im Blick – digital, unabhängig und jederzeit verfügbar. Kein Papierchaos, keine komplizierten Kalender – du entscheidest, wie du deine Felder dokumentierst.</p>
          </div>
          <div className="flex flex-col md:flex-row flex-1 gap-4 w-full">
            {!keycloak.authenticated ? (
              <>
            <button onClick={() => keycloak.login({ redirectUri: window.location.origin + "/map" })} className="home-btn rounded-lg">Login</button>
            <button className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-6 rounded-lg transition-colors w-full md:w-fit">Registrieren</button>
              </>
    
        ) : (
          <>
          <button onClick={() => navigate("/map")} className="home-btn rounded-lg">zum Feldkalender</button>
          <button onClick={() => navigate("/profile")} className="home-btn rounded-lg">Profil</button>
          </>
            
          )}
          </div>
        </div>
        <img src="/img/phone.png" alt="ico" className="order-2 rounded-xl w-full md:w-2/5" />
      </div>
  
      <div className="flex flex-col gap-4 md:flex-row items-center justify-around w-full px-6 md:px-10 my-10">
        <img src="/img/traktor.jpg" alt="ico" className="order-1 rounded-xl w-full md:w-2/5" />
        <div className="flex flex-col gap-4 md:gap-12 order-2 w-full md:w-2/6">
          <div className="flex flex-1 flex-col">
            <h3 className="text-4xl font-bold mb-2">Effizient arbeiten mit Ackerplus</h3>
            <p className="text-xl text-gray-600">Mit Ackerplus hast du alle Felder und Arbeiten im Blick. Spare Zeit, plane smarter und dokumentiere alle Schritte – von Aussaat bis Ernte – direkt digital.</p>
          </div>
          <div className="flex flex-col gap-2 flex-1 w-full">
            <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Verfügbar auf Handy & PC</span>
            </div>
            <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Unabhängig & flexibel</span>
            </div>
                  <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Kostenlos testen</span>
            </div>
          </div>
          <div className="flex flex-1 w-full">
            <button onClick={() => navigate("/subscription")} className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-6 rounded-lg transition-colors w-full md:w-fit">
              Jetzt testen
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 md:flex-row-reverse items-center justify-around w-full px-6 md:px-10 my-10">
        <img src="/img/landwirt.jpg" alt="ico" className="order-1 rounded-xl w-full md:w-2/5" />
        <div className="flex flex-col gap-4 md:gap-12 order-2 w-full md:w-2/6">
          <div className="flex flex-1 flex-col">
            <h3 className="text-4xl font-bold mb-2">Alles auf einen Blick</h3>
            <p className="text-xl text-gray-600">Verwalte deine Parzellen, exportiere Schlagkarten und behalte den Fortschritt deiner Kulturen im Blick – alles direkt auf deinem Smartphone oder Tablet. So hast du deine Landwirtschaft immer unter Kontrolle, egal wo du bist.</p>
          </div>
          <div className="flex flex-col gap-2 flex-1 w-full">
            <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Schlagkarten exportieren</span>
            </div>
            <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Parzellen verwalten</span>
            </div>
                  <div className="flex flex-1 gap-3 items-center">
              <PiCheckFatLight color="#37813b" size={20} />
              <span>Feldkalender führen</span>
            </div>
          </div>
          <div className="flex flex-1 w-full">
            <button onClick={() => navigate("/subscription")} className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-6 rounded-lg transition-colors w-full md:w-fit">
              Zu den Plänen
            </button>
          </div>
        </div>
      </div>
      
    </BaseLayout>
  )
}